<template>
    <div class="flex border-t border-gray-200 bg-white draggable">

        <!-- Draggable handle. -->
        <div class="w-6 flex-shrink-0 self-start py-1.5" v-if="editable">
            <div class="w-5 h-5 flex items-center">
                <i class="fa fa-bars fa-fw text-xs text-gray-300 hover:text-gray-400 cursor-move handle"
                   v-if="editable"></i>
            </div>
        </div>

        <!-- Reference. -->
        <div class="w-16 flex">
            <page-cell
                class="text-sm -my-px px-2 py-1.5 border border-gray-200 bg-white"
                :placeholder="item.defaultReference"
                v-model="item.reference"
                @input="update"
                @change="inspectionTestPlan.addSnapshot()"
                :read-only="!editable"
            ></page-cell>
        </div>

        <!-- Description. -->
        <div class="flex-1 flex">
            <autoresizable-textarea :height="getHeight" ref="autoresizable-textarea" v-if="editable">
                <textarea
                    placeholder="Description..."
                    class="text-sm -ml-px -my-px px-2 py-1.5 border border-gray-200 shadow-none relative hover:z-10 focus:z-20 resize-none"
                    type="text"
                    ref="description"
                    v-model="item.description"
                    @input="update"
                    @change="inspectionTestPlan.addSnapshot()"
                    rows="1"
                ></textarea>
            </autoresizable-textarea>
            <div v-else
                 class="w-full text-sm -ml-px -my-px px-2 py-1.5 bg-white border border-gray-200 shadow-none relative shadow-none relative0"
                 v-text="item.description"
            ></div>
        </div>

        <!-- Quantity. -->
        <div class="w-20 -ml-px flex">
            <page-cell
                class="text-sm -ml-px -my-px px-2 py-1.5 border border-gray-200 bg-white"
                placeholder="Qty"
                v-model="item.quantity"
                @input="update"
                @change="inspectionTestPlan.addSnapshot()"
                :read-only="!editable"
            ></page-cell>
        </div>

        <!-- Units of measure. -->
        <div class="w-20 -ml-px flex">
            <page-cell
                class="text-sm -ml-px -my-px px-2 py-1.5 border border-gray-200 bg-white"
                placeholder="Unit..."
                v-model="item.unit"
                @input="update"
                @change="inspectionTestPlan.addSnapshot()"
                :read-only="!editable"
            ></page-cell>
        </div>

        <!-- Test Method. -->
        <div class="w-40 -ml-px flex">
            <autoresizable-textarea :height="getHeight" ref="autoresizable-textarea" v-if="editable">
                <textarea
                    placeholder="Test method..."
                    class="text-sm -ml-px -my-px px-2 py-1.5 border border-gray-200 shadow-none relative hover:z-10 focus:z-20 resize-none"
                    type="text"
                    v-model="item.testMethod"
                    @input="update"
                    @change="inspectionTestPlan.addSnapshot()"
                    rows="1"
                ></textarea>
            </autoresizable-textarea>
            <div v-else
                 class="w-full text-sm -ml-px -my-px px-2 py-1.5 bg-white border border-gray-200 shadow-none relative shadow-none relative0"
                 v-text="item.testMethod"
            ></div>
        </div>

        <!-- Minimum Frequency. -->
        <div class="w-40 -ml-px flex">
            <autoresizable-textarea :height="getHeight" ref="autoresizable-textarea" v-if="editable">
                <textarea
                    placeholder="Minimum frequency..."
                    class="text-sm -ml-px -my-px px-2 py-1.5 border border-gray-200 shadow-none relative hover:z-10 focus:z-20 resize-none"
                    type="text"
                    v-model="item.minimumFrequency"
                    @input="update"
                    @change="inspectionTestPlan.addSnapshot()"
                    rows="1"
                ></textarea>
            </autoresizable-textarea>
            <div v-else
                 class="w-full text-sm -ml-px -my-px px-2 py-1.5 bg-white border border-gray-200 shadow-none relative shadow-none relative0"
                 v-text="item.minimumFrequency"
            ></div>
        </div>

        <!-- Dropdown. -->
        <div class="w-6 flex-shrink-0 ml-2 self-start py-1.5" v-if="editable">
            <ui-dropdown menu-class="p-3 w-48" v-if="editable">
                <template #default="{ toggle }">
                    <button @click="toggle"
                            class="w-5 h-5 flex items-center justify-center text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative rounded">
                        <i class="fa fa-ellipsis-h fa-fw"></i>
                    </button>
                </template>
                <template #menu="{ close }">
                    <ui-dropdown-item v-if="! inspectionTestPlan.cannot_be_edited_by_authed_user" icon="fas fa-copy"
                                      @click="duplicateItem(); close();">Duplicate
                    </ui-dropdown-item>
                    <ui-dropdown-item v-if="! inspectionTestPlan.cannot_be_edited_by_authed_user" icon="fas fa-trash"
                                      danger
                                      @click="deleteItem">Delete
                    </ui-dropdown-item>
                </template>
            </ui-dropdown>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        inspectionTestPlan: Object,
        task: Object,
        item: Object,
        editable: true,
        update: Function,
    },
    data() {
        return {
            rate: this.item.rate,
            quantity: this.item.quantity,
            total: this.item.total,
            updating: false,
        }
    },
    methods: {
        getHeight(el) {
            let max = 0;
            for (let area of el.closest('.draggable').getElementsByTagName('textarea')) {
                area.setAttribute('style', 'height:auto')
            }
            for (let area of el.closest('.draggable').getElementsByTagName('textarea')) {
                max = Math.max(max, area.scrollHeight + 2);
            }
            for (let area of el.closest('.draggable').getElementsByTagName('textarea')) {
                area.setAttribute('style', 'height:' + max + 'px;overflow-y:hidden;')
            }
            return max + 'px';
        },
        deleteItem() {
            this.$modals.confirmDelete({
                title: `Delete item ${this.item.ref}`,
                button: 'Yes, delete item',
                handle: () => {
                    this.task.items = this.task.items.filter((item) => item !== this.item)
                    this.inspectionTestPlan.update()
                    this.inspectionTestPlan.addSnapshot()
                }
            })
        },
        duplicateItem() {
            this.task.items.splice(this.task.items.indexOf(this.item), 0, {...this.item});
            this.inspectionTestPlan.update()
            this.inspectionTestPlan.addSnapshot()
        },
    }
}
</script>
